module.exports = __webpack_public_path__ + "static/media/overview.b3dd894d.svg";